import { useDarkMode } from "@/hooks/useDarkMode";
import { cn } from "@/lib/utils";

const WideButton = (props: {
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  children?: any;
  type?: "filled" | "outlined";
  buttonType?: "button" | "submit" | "reset";
  "aria-label"?: string;
}) => {
  const isDark = useDarkMode();
  const outlined = props.type === "outlined";
  
  // Warn if button has no children and no aria-label (icon-only button without accessible name)
  if (!props.children && !props["aria-label"]) {
    console.error(
      "WideButton: Button without text content is missing aria-label. Please add an accessible name for screen readers."
    );
  }
  
  return (
    <button
      type={props.buttonType || "button"}
      disabled={props.disabled}
      // style={{
      //   backgroundColor: props.disabled
      //     ? isDark
      //       ? "#313A71"
      //       : "#767586"
      //     : isDark
      //       ? outlined
      //         ? "#19165C"
      //         : "#4640BE"
      //       : outlined
      //         ? "#A39FE8"
      //         : "#19165C",
      //   borderWidth: outlined ? 2 : 0,
      //   borderColor: isDark ? "#A39FE8" : "#19165C",
      // }}
      className={cn(
        "w-full min-h-[44px]",
        props.disabled
          ? "px-4 py-2 rounded-[8px] bg-bg-brand-primary-disabled text-fg-neutral-minimal border border-border-token-neutral-minimal"
          : "px-4 py-2 rounded-[8px] bg-bg-brand-primary-default hover:bg-bg-brand-primary-hover active:bg-bg-brand-primary-active text-fg-neutral-onFilled focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:outline-none",
        props.className,
      )}
      onClick={props.onClick}
      aria-label={props["aria-label"]}
    >
      <span
        
        // className="text-center text-fg-neutral-onFilled title-s-semibold"
        className={cn(
          "text-center title-s-semibold",
          props.disabled
            ? "text-fg-neutral-minimal"
            : "text-fg-neutral-onFilled",
          props.className,
        )}
      >
        {props.children}
      </span>
    </button>
  );
};

export default WideButton;
